import download from "downloadjs";

import API from "api/base/base";
import { appendQueryArgs } from "utils/apiHelpers";
import { axios } from "utils/axios";

const Users = new API({ controller: "users" });

Object.assign(Users, {
  getInvitedUser(payload) {
    return axios.post(`${this.url}/onboard_token`, payload);
  },
  getOnboardingGroups(payload) {
    return axios.post(`${this.url}/onboard_groups`, payload);
  },
  signUpUser(payload) {
    return axios.post(`${this.url}/onboard_password`, payload);
  },
  requestPasswordReset(payload) {
    return axios.post(`${this.url}/reset_password_request`, payload);
  },
  resendInvitation(payload) {
    return axios.post(`${this.url}/resend_invitation`, payload);
  },
  getPasswordToken(payload) {
    return axios.post(`${this.url}/reset_password_token`, payload);
  },
  passwordReset(payload) {
    return axios.post(`${this.url}/password_reset`, payload);
  },
  prototype(payload) {
    return axios.get(appendQueryArgs(`${this.url}/prototype`, payload));
  },
  budgetApprovers(payload) {
    return axios.get(appendQueryArgs(`${this.url}/budget_approvers`, payload));
  },
  sampleCSV(payload) {
    return axios
      .get(appendQueryArgs(`${this.url}/sample_csv`, payload))
      .then((response) =>
        download(response.data, "diverst_import.csv", response.content_type),
      );
  },
});

export default Users;
